var map = {
	"./aeroland-box-image-01.png": 5903,
	"./aeroland-box-image-02.png": 3415,
	"./aeroland-box-image-03.png": 8815,
	"./aeroland-box-image-04.png": 1182,
	"./aeroland-box-image-05.png": 3786,
	"./aeroland-box-image-06.png": 9788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6816;